(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["awakearl-home"] && !Shopify.designMode) return;
  try {
    
  function mountAwakearlCarousel(root) {
    for (const carousel of root.querySelectorAll('[data-ah-carousel]')) {
      if (carousel.dataset.ahReady) continue;
      const track = carousel.querySelector('[data-ah-track]');
      const controls = carousel.querySelector('[data-ah-controls]');
      const count = carousel.querySelector('[data-ah-count]');
      const total = track.children.length;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const toggle = carousel.querySelector('[data-ah-toggle]');
      let paused = motion.matches;
      let hovered = false;
      let focused = false;
      let inView = false;
      const syncToggle = () => {
        toggle.setAttribute('aria-label', paused ? toggle.dataset.ahPlayLabel : toggle.dataset.ahPauseLabel);
        toggle.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
      };
      const current = () => Math.min(total - 1, Math.round(track.scrollLeft / (track.clientWidth || 1)));
      const move = (direction) => {
        const next = (current() + direction + total) % total;
        track.scrollTo({
          left: next * track.clientWidth,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };
      carousel.querySelector('[data-ah-previous]').addEventListener('click', () => move(-1));
      carousel.querySelector('[data-ah-next]').addEventListener('click', () => move(1));
      track.addEventListener('scroll', () => {
        count.textContent = (current() + 1) + ' / ' + total;
      }, { passive: true });
      toggle.addEventListener('click', () => { paused = !paused; syncToggle(); });
      carousel.addEventListener('mouseenter', () => { hovered = true; });
      carousel.addEventListener('mouseleave', () => { hovered = false; });
      carousel.addEventListener('focusin', () => { focused = true; });
      carousel.addEventListener('focusout', (event) => { focused = carousel.contains(event.relatedTarget); });
      motion.addEventListener('change', () => { paused = motion.matches; syncToggle(); });
      const observer = new IntersectionObserver(([entry]) => { inView = entry.isIntersecting; });
      observer.observe(carousel);
      const timer = setInterval(() => {
        if (!carousel.isConnected) { clearInterval(timer); observer.disconnect(); return; }
        if (!paused && !hovered && !focused && inView && !document.hidden) move(1);
      }, 5000);
      syncToggle();
      carousel.dataset.ahReady = 'true';
      controls.hidden = false;
    }
  }
  mountAwakearlCarousel(document);
  document.addEventListener('shopify:section:load', (event) => mountAwakearlCarousel(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
